module.exports = __webpack_public_path__ + "img/firewall-image.17d01ff.svg";